import { hasKey } from '@betty/i18n';
import { formatAmount } from '@betty/toolkit/utils';
import { DepositPromo } from '../../../state/deposit/deposit.types';

export const calculateReward = (promo: DepositPromo, selectedAmount = 0) => {
  const { rewardTarget } = promo.rewards[0] || {};
  const { percentage = 0, maximumRewardAmount = 0 } = promo.subTypeMeta || {};

  const rewardAmount = Math.min(
    (selectedAmount * percentage) / 100,
    maximumRewardAmount,
  );

  return `${formatAmount(rewardAmount)} ${rewardTarget}`;
};

export const getRewardLabel = (
  promo: DepositPromo,
  t: (key: string, options: Record<string, unknown>) => string,
) => {
  const { rewardTarget, rewardAmount = 0 } = promo.rewards[0] || {};

  return hasKey(`wallet:deposit${rewardTarget}Label`)
    ? t(`deposit${rewardTarget}Label`, {
        rewardAmount,
        rewardTarget,
      })
    : t(`depositRewardDefaultLabel`, {
        rewardAmount:
          rewardTarget === 'Bonus' ? formatAmount(rewardAmount) : rewardAmount,
        rewardTarget,
      });
};

export const getPromoLocked = (promo: DepositPromo, selectedAmount = 0) => {
  const { minimumQualificationAmount = 0 } = promo.subTypeMeta || {};

  return !selectedAmount || minimumQualificationAmount > selectedAmount;
};
